// extracted by mini-css-extract-plugin
export default {"menu":"MainMenu_menu__yAY1q","item":"MainMenu_item__qpA0-","bg":"MainMenu_bg__N4fJF","new":"MainMenu_new__R0JEp","text":"MainMenu_text__efYXe"};